interface Props {
  /** Назва іконки Material Symbols — та сама, що й `Icons.<name>` у Flutter. */
  name: string;
  size?: number;
  className?: string;
}

/**
 * Іконка з набору Material Symbols Rounded.
 *
 * Flutter використовує `Icons.*_rounded` із того самого набору, тож назви
 * збігаються один в один і вигляд не розходиться з мобільним клієнтом.
 */
export function Icon({ name, size = 24, className }: Props): React.JSX.Element {
  return (
    <span
      className={className === undefined ? 'icon' : `icon ${className}`}
      style={{ fontSize: `${String(size)}px` }}
      aria-hidden="true"
    >
      {name}
    </span>
  );
}
